// Main JS entry point: mobile menu, accordions, and accessible nav behavior
(function(){
	if ( typeof document === 'undefined' ) return;

	// Diagnostic: log clicks on any anchor that contains a hash so we can see
	// whether the user is actually clicking a fragment link (e.g. /genetics#cause)
	document.addEventListener('click', function(e){
		var a = e.target.closest && e.target.closest('a');
		if (!a) return;
		var href = a.getAttribute && a.getAttribute('href');
		if (!href) return;
		if (href.indexOf('#') !== -1) {
			console.log('Anchor clicked with hash:', href, 'text:', (a.textContent||'').trim());
		}
	});

	// Diagnostic: log referrer and initial scroll position when page loads
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function(){
			console.log('page load: location=', window.location.href, 'referrer=', document.referrer, 'initialScrollY=', window.scrollY);
		});
	} else {
		console.log('page load: location=', window.location.href, 'referrer=', document.referrer, 'initialScrollY=', window.scrollY);
	}

	var body = document.body;
	var mobileToggle = document.getElementById('mobile-menu-toggle');
	var mobileMenu = document.getElementById('mobile-menu');
	var mobileClose = mobileMenu ? mobileMenu.querySelector('.mobile-close') : null;

	function openMobileMenu(){
		if (!mobileMenu) return;
		mobileMenu.setAttribute('aria-hidden','false');
		if ( mobileToggle ) mobileToggle.setAttribute('aria-expanded','true');
		body.classList.add('mobile-menu-open');
		if ( mobileToggle ) mobileToggle.classList.add('open');
		// trap focus if possible
		var inner = mobileMenu.querySelector('.mobile-menu-inner');
		if ( inner && inner.focus ) inner.focus();
	}

	function closeMobileMenu(){
		if (!mobileMenu) return;
		mobileMenu.setAttribute('aria-hidden','true');
		mobileToggle.setAttribute('aria-expanded','false');
		body.classList.remove('mobile-menu-open');
		mobileToggle.classList.remove('open');
		mobileToggle.focus();
	}

	if ( mobileToggle && mobileMenu ){
		mobileToggle.addEventListener('click', function(e){
			var isOpen = mobileMenu.getAttribute('aria-hidden') === 'false';
			if ( isOpen ) closeMobileMenu(); else openMobileMenu();
		});
	}

	if ( mobileClose ){ mobileClose.addEventListener('click', closeMobileMenu); }

	// Close when clicking the overlay (i.e., the mobile-menu element but outside the inner)
	if ( mobileMenu ){
		mobileMenu.addEventListener('click', function(e){
			var inner = mobileMenu.querySelector('.mobile-menu-inner');
			if ( inner && !inner.contains(e.target) ){
				closeMobileMenu();
			}
		});
	}

	// Close on ESC
	document.addEventListener('keydown', function(e){
		if ( e.key === 'Escape' && mobileMenu && mobileMenu.getAttribute('aria-hidden') === 'false' ){
			closeMobileMenu();
		}
	});

	// Mobile accordion behavior
	document.addEventListener('click', function(e){
		// Check if click was on the accordion label - if so, navigate to the page
		var label = e.target.closest && e.target.closest('.mobile-accordion-label');
		if ( label ){
			var acc = label.closest('.mobile-accordion');
			if ( acc ){
				var url = acc.getAttribute('data-url');
				if ( url ){
					window.location.href = url;
					return; // Don't toggle accordion
				}
			}
		}

		// Otherwise, handle normal accordion toggle behavior
		var acc = e.target.closest && e.target.closest('.mobile-accordion');
		if ( acc ){
			var expanded = acc.getAttribute('aria-expanded') === 'true';
			// Toggle aria-expanded and open class
			acc.setAttribute('aria-expanded', expanded ? 'false' : 'true');
			acc.classList.toggle('open', !expanded);
			var parent = acc.parentNode;
			if ( parent ){
				parent.classList.toggle('open', !expanded);
				// Show/hide submenu if present
				var submenu = parent.querySelector('.mobile-submenu');
				if ( submenu ){
					submenu.hidden = expanded; // when expanded=false -> show (hidden=false)
				}
			}
		}
	});

	// Desktop keyboard menu accessibility: toggle submenu with Enter/Space
	document.addEventListener('click', function(e){
		var chev = e.target.closest && e.target.closest('.chev-toggle');
		if ( chev ){
			var li = chev.closest('.menu-item');
			if ( li ){
				var anchor = li.querySelector('a[aria-expanded]');
				var expanded = anchor.getAttribute('aria-expanded') === 'true';
				anchor.setAttribute('aria-expanded', expanded ? 'false' : 'true');
				li.classList.toggle('active', !expanded);
			}
		}
	});

})();

// Masthead hide/show on scroll direction (reclaims space on scroll down)
(function() {
	if (typeof document === 'undefined') return;

	var masthead = document.getElementById('masthead');
	if (!masthead) return;
	var hasInitializedMasthead = false;

	function measureHeights() {
		if (!hasInitializedMasthead) {
			// Prevent initial paint from animating body padding.
			document.body.style.transition = 'none';
		}

		var headerH = masthead.offsetHeight || 0;
		var topBar = document.querySelector('.top-bar');
		// var topBarH = topBar ? (topBar.offsetHeight || 0) : 0;
		// Added this below to accomodate for hiding nav on upscroll
		var topBarH = topBar ? (0 || 0) : 0;

		document.body.style.setProperty('--masthead-height', headerH + 'px');
		document.body.style.setProperty('--topbar-height', topBarH + 'px');
		document.body.classList.add('masthead-fixed');
	}

	function finalizeMastheadInit() {
		if (hasInitializedMasthead) return;
		window.requestAnimationFrame(function() {
			document.body.style.removeProperty('transition');
			hasInitializedMasthead = true;
		});
	}

	var prefersReducedMotion = false;
	try {
		prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	} catch (e) {}

	var lastY = window.scrollY || 0;
	var ticking = false;
	// How far the user must scroll (in px) before we consider it "real"
	// scroll and toggle the masthead. Kept small so it reacts quickly.
	var thresholdPx = 5;

	function updateVisibility() {
		ticking = false;

		var currentY = window.scrollY || 0;

		// Always show at the very top.
		if (currentY <= 5) {
			document.body.classList.remove('masthead-hidden');
			lastY = currentY;
			return;
		}

		// Don't interfere when the mobile menu is open.
		if (document.body.classList.contains('mobile-menu-open')) {
			document.body.classList.remove('masthead-hidden');
			lastY = currentY;
			return;
		}

		var delta = currentY - lastY;

		// Ignore tiny scroll jitter.
		if (Math.abs(delta) < thresholdPx) return;

		// Scrolling down: hide. Scrolling up: show.
		if (delta > 0) {
			document.body.classList.add('masthead-hidden');
		} else {
			document.body.classList.remove('masthead-hidden');
		}

		lastY = currentY;
	}

	function onScroll() {
		if (ticking) return;
		if (prefersReducedMotion) {
			updateVisibility();
			return;
		}
		ticking = true;
		window.requestAnimationFrame(updateVisibility);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function() {
			measureHeights();
			finalizeMastheadInit();
		});
	} else {
		measureHeights();
		finalizeMastheadInit();
	}

	window.addEventListener('resize', function() {
		measureHeights();
	}, { passive: true });

	window.addEventListener('scroll', onScroll, { passive: true });
})();

// Accessible accordion behavior for page-impact accordions
(function(){
	if ( typeof document === 'undefined' ) return;
	var accRoot = document.querySelector('.accordion');
	if ( !accRoot ) return;

	var items = Array.prototype.slice.call(accRoot.querySelectorAll('.accordion-item'));
	var headers = items.map(function(it){ return it.querySelector('.accordion-header'); });

	function closePanel(item){
		var h = item.querySelector('.accordion-header');
		var p = item.querySelector('.accordion-panel');
		if ( h && p ){
			h.setAttribute('aria-expanded','false');
			p.hidden = true;
			p.setAttribute('aria-hidden','true');
			var icon = h.querySelector('.accordion-icon'); if ( icon ) icon.textContent = '+';
			item.classList.remove('open');
		}
	}

	function openPanel(item){
		var h = item.querySelector('.accordion-header');
		var p = item.querySelector('.accordion-panel');
		if ( h && p ){
			h.setAttribute('aria-expanded','true');
			p.hidden = false;
			p.setAttribute('aria-hidden','false');
			var icon = h.querySelector('.accordion-icon'); if ( icon ) icon.textContent = '\u2212';
			item.classList.add('open');
		}
	}

	headers.forEach(function(h, idx){
		if ( !h ) return;
		// make whole header clickable
		h.addEventListener('click', function(e){
			var expanded = h.getAttribute('aria-expanded') === 'true';
			if ( expanded ) closePanel(items[idx]); else openPanel(items[idx]);
		});

		// keyboard support
		h.addEventListener('keydown', function(e){
			// Toggle on Enter or Space
			if ( e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar' ){
				e.preventDefault(); h.click();
				return;
			}
			// Move focus
			if ( e.key === 'ArrowDown' ){ e.preventDefault(); var next = headers[(idx+1) % headers.length]; if ( next ) next.focus(); return; }
			if ( e.key === 'ArrowUp' ){ e.preventDefault(); var prev = headers[(idx-1+headers.length) % headers.length]; if ( prev ) prev.focus(); return; }
			if ( e.key === 'Home' ){ e.preventDefault(); if ( headers[0] ) headers[0].focus(); return; }
			if ( e.key === 'End' ){ e.preventDefault(); if ( headers[headers.length-1] ) headers[headers.length-1].focus(); return; }
		});
	});

	// start all closed
	items.forEach(function(it){ closePanel(it); });
})();

// Tabbed content behavior: accessible tabs (click + keyboard)
(function(){
  if ( typeof document === 'undefined' ) return;
  var tabContainers = document.querySelectorAll('.tabbed-content');
  if ( !tabContainers || !tabContainers.length ) return;

  tabContainers.forEach(function(container){
    var tabs = Array.prototype.slice.call(container.querySelectorAll('[role="tab"]'));
    var panels = Array.prototype.slice.call(container.querySelectorAll('[role="tabpanel"]'));
    if ( !tabs.length || !panels.length ) return;

    function activateTab(tab){
      tabs.forEach(function(t){
        var sel = t === tab;
        t.setAttribute('aria-selected', sel ? 'true' : 'false');
        t.tabIndex = sel ? 0 : -1;
      });
      panels.forEach(function(p){
        p.hidden = p.getAttribute('aria-labelledby') !== tab.id;
      });
      tab.focus();
    }

    // click
    tabs.forEach(function(t){
      t.addEventListener('click', function(e){
        activateTab(t);
      });

      t.addEventListener('keydown', function(e){
        var idx = tabs.indexOf(t);
        if ( e.key === 'ArrowRight' || e.key === 'Right' ){
          e.preventDefault();
          var next = tabs[(idx + 1) % tabs.length];
          activateTab(next);
        }
        if ( e.key === 'ArrowLeft' || e.key === 'Left' ){
          e.preventDefault();
          var prev = tabs[(idx - 1 + tabs.length) % tabs.length];
          activateTab(prev);
        }
        if ( e.key === 'Home' ){
          e.preventDefault();
          activateTab(tabs[0]);
        }
        if ( e.key === 'End' ){
          e.preventDefault();
          activateTab(tabs[tabs.length - 1]);
        }
      });
    });

    // ensure initial state
    var initial = tabs.find(function(t){ return t.getAttribute('aria-selected') === 'true'; }) || tabs[0];
    activateTab(initial);
  });
})();

// Exit link modal functionality
(function(){
	if ( typeof document === 'undefined' ) return;

	var exitModal = document.getElementById('exit-modal');
	var confirmBtn = document.getElementById('Leave_Site');
	var cancelBtn = document.getElementById('Cancel_Leaving_Site');
	var currentExitLink = null;

	// Function to show exit modal
	function showExitModal(targetUrl) {
		if (!exitModal) return;
		
		currentExitLink = targetUrl;
		
		// Update the confirm button's href if it exists
		if (confirmBtn) {
			confirmBtn.href = targetUrl;
		}
		
		exitModal.showModal();
	}

	// Function to hide exit modal
	function hideExitModal() {
		if (!exitModal) return;
		exitModal.close();
		currentExitLink = null;
	}

	// Handle clicks on exit-link elements
	document.addEventListener('click', function(e) {
		var exitLink = e.target.closest('.exit-link');
		if (!exitLink) return;
		
		e.preventDefault(); // Prevent default link behavior
		
		var targetUrl = exitLink.getAttribute('href');
		if (!targetUrl) return;
		
		showExitModal(targetUrl);
	});

	// Handle confirm button click
	if (confirmBtn) {
		confirmBtn.addEventListener('click', function(e) {
			if (currentExitLink) {
				// Open the link in a new tab
				window.open(currentExitLink, '_blank', 'noopener,noreferrer');
				hideExitModal();
			}
		});
	}

	// Handle cancel button click
	if (cancelBtn) {
		cancelBtn.addEventListener('click', function(e) {
			hideExitModal();
		});
	}

	// Handle clicking outside the modal or ESC key
	if (exitModal) {
		exitModal.addEventListener('click', function(e) {
			if (e.target === exitModal) {
				hideExitModal();
			}
		});

		exitModal.addEventListener('cancel', function(e) {
			hideExitModal();
		});
	}
})();

// Smooth scroll for subnav links and deeplinks with offset for sticky subnav
(function(){
	if ( typeof document === 'undefined' ) return;

	function getSubnavOffset() {
		var subnav = document.querySelector('.subnav');
		if (!subnav) return 0;
		
		// Base offset is subnav height + 60px
		var baseOffset = subnav.offsetHeight + 80;
		
		// Add extra 10px offset for mobile (900px and below)
		var isMobile = window.innerWidth <= 900;
		var extraMobileOffset = isMobile ? -20 : 0;
		
		var totalOffset = baseOffset + extraMobileOffset;
		console.log('getSubnavOffset: mobile=', isMobile, 'baseOffset=', baseOffset, 'extraOffset=', extraMobileOffset, 'total=', totalOffset);
		
		return totalOffset;
	}

	function smoothScrollToAnchor(targetId, offset) {
		var target = document.getElementById(targetId);
		if (!target) return;
		var isMobile = window.innerWidth <= 900;
		offset += isMobile ? 40 : 0;
		var targetPosition = target.getBoundingClientRect().top + window.pageYOffset - offset;
		
		console.log('smoothScrollToAnchor: targetId=', targetId, 'offset=', offset, 'targetPosition=', targetPosition);
		console.log('smoothScrollToAnchor: target.getBoundingClientRect().top=', target.getBoundingClientRect().top, 'window.pageYOffset=', window.pageYOffset);
		
		window.scrollTo({
			top: targetPosition,
			behavior: 'smooth'
		});
	}

	// Handle clicks on subnav links
	document.addEventListener('click', function(e) {
		var link = e.target.closest('.subnav-link');
		if (!link) return;
		
		var href = link.getAttribute('href');
		if (!href || !href.startsWith('#')) return;
		
		e.preventDefault();
		var targetId = href.substring(1);
		var offset = getSubnavOffset();
		smoothScrollToAnchor(targetId, offset);
		
		// Update URL without triggering scroll
		if (history.pushState) {
			history.pushState(null, null, href);
		}
	});

	// Handle deeplinks on page load
	function handleDeeplink() {
		var hash = window.location.hash;
		// If there's no hash, do nothing here — this prevents accidental jumping when
		// landing on pages like /genetics/ (the header contains links with fragments
		// such as /genetics#cause which should not auto-trigger unless the URL
		// actually contains a hash).
		if (!hash || hash.length <= 1) {
			console.log('handleDeeplink: no hash present, skipping automatic scroll');
			return;
		}
		
		var targetId = hash.substring(1);
		var offset = getSubnavOffset();
		console.log('handleDeeplink: handling hash', hash, '->', targetId, 'with offset', offset);
		// Small delay to ensure subnav is rendered and positioned
		setTimeout(function() {
			smoothScrollToAnchor(targetId, offset);
		}, 100);
	}

	// Handle deeplinks on page load
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', handleDeeplink);
	} else {
		handleDeeplink();
	}

	// Handle hash changes (back/forward navigation)
	window.addEventListener('hashchange', function() {
		var hash = window.location.hash;
		if (!hash || hash.length <= 1) return;
		
		var targetId = hash.substring(1);
		var offset = getSubnavOffset();
		smoothScrollToAnchor(targetId, offset);
	});

	// Active state management for jump links based on scroll position
	function updateActiveJumpLinks() {
		var subnavLinks = document.querySelectorAll('.subnav-link');
		console.log('Found subnav links:', subnavLinks.length);
		if (!subnavLinks.length) return;

		var scrollPosition = window.pageYOffset;
		var offset = getSubnavOffset();
		console.log('Scroll position:', scrollPosition, 'Offset:', offset);

		// Get all anchor elements that have corresponding jump links
		var anchors = [];
		subnavLinks.forEach(function(link) {
			var href = link.getAttribute('href');
			if (href && href.startsWith('#')) {
				var targetId = href.substring(1);
				var target = document.getElementById(targetId);
				if (target) {
					var targetTop = target.getBoundingClientRect().top + window.pageYOffset - offset;
					anchors.push({
						id: targetId,
						element: target,
						link: link,
						top: targetTop
					});
					console.log('Found anchor:', targetId, 'at position:', targetTop);
				}
			}
		});

		// Sort anchors by their position on the page
		anchors.sort(function(a, b) {
			return a.top - b.top;
		});

		var activeAnchor = null;

		// Find the current active anchor
		for (var i = 0; i < anchors.length; i++) {
			var anchor = anchors[i];
			var nextAnchor = anchors[i + 1];

			// Check if we're past this anchor
			if (scrollPosition >= anchor.top - 50) { // 50px buffer for better UX
				// If there's a next anchor, make sure we're not past it
				if (nextAnchor) {
					if (scrollPosition < nextAnchor.top - 50) {
						activeAnchor = anchor;
						break;
					}
				} else {
					// This is the last anchor
					activeAnchor = anchor;
				}
			}
		}

		console.log('Active anchor:', activeAnchor ? activeAnchor.id : 'none');

		// Update active classes
		subnavLinks.forEach(function(link) {
			link.classList.remove('active');
		});

		if (activeAnchor) {
			activeAnchor.link.classList.add('active');
			console.log('Added active class to:', activeAnchor.id);
		}
	}

	// Set up scroll listener with throttling for performance
	var scrollTimeout;
	function throttledScrollHandler() {
		if (scrollTimeout) {
			clearTimeout(scrollTimeout);
		}
		scrollTimeout = setTimeout(updateActiveJumpLinks, 10);
	}

	window.addEventListener('scroll', throttledScrollHandler);

	// Update active states on page load and when hash changes
	function initializeActiveStates() {
		// If we navigated to this page without a hash (regular link click) but
		// the browser restored scroll to a sub-section, that causes updateActiveJumpLinks
		// to mark that sub-section active. To avoid this unexpected jump when
		// clicking top-level nav items, reset scroll to top for fresh navigations
		// (but preserve back/forward behavior).
		try {
			var navEntries = performance.getEntriesByType && performance.getEntriesByType('navigation');
			var navType = (navEntries && navEntries[0] && navEntries[0].type) || (performance.navigation && performance.navigation.type === 2 ? 'back_forward' : 'navigate');
			console.log('initializeActiveStates: navigation type =', navType, 'location.hash=', window.location.hash, 'initialScrollY=', window.scrollY);
			if ((!window.location.hash || window.location.hash.length <= 1) && navType === 'navigate' && window.scrollY > 50) {
				console.log('initializeActiveStates: resetting scroll to top to avoid landing inside an anchor');
				window.scrollTo(0,0);
			}
		} catch (err) {
			// ignore errors and continue
			console.warn('initializeActiveStates: navigation detection failed', err);
		}
		setTimeout(updateActiveJumpLinks, 100); // Small delay to ensure layout is complete
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initializeActiveStates);
	} else {
		initializeActiveStates();
	}

	// Also update active state when clicking jump links
	document.addEventListener('click', function(e) {
		var link = e.target.closest('.subnav-link');
		if (link) {
			// Small delay to let the smooth scroll start, then update active states
			setTimeout(function() {
				// Remove active from all links
				document.querySelectorAll('.subnav-link').forEach(function(l) {
					l.classList.remove('active');
				});
				// Add active to clicked link
				link.classList.add('active');
			}, 50);
		}
	});
})();

// ISI Preview visibility based on scroll position
(function() {
	if (typeof document === 'undefined') return;

	var isiPreview = document.getElementById('isi-preview');
	var isi = document.getElementById('isi');
	

	
	// Add scroll listener
	window.addEventListener('scroll', handleISIPreviewVisibility);

	function handleISIPreviewVisibility() {
		if (!isiPreview || !isi) {
			return;
		}
	
		var scrollPosition = window.pageYOffset + window.innerHeight;
		var previewHeight = isiPreview ? (isiPreview.offsetHeight || isiPreview.getBoundingClientRect().height) : 0;
		var previewBottom = 0;
		try {
			var computedBottom = window.getComputedStyle(isiPreview).bottom;
			if (computedBottom) {
				previewBottom = parseFloat(computedBottom) || 0;
			}
		} catch (e) {}
		scrollPosition -= (previewHeight + previewBottom);
		var isiPosition = isi.getBoundingClientRect().top + window.pageYOffset;

		// Show preview when the isi comes into view
		if (scrollPosition >= isiPosition) {
			isiPreview.classList.add('hidden');
		} else {
			isiPreview.classList.remove('hidden');
		}
	}

	/// on page load, check visibility
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', handleISIPreviewVisibility);
	} else {
		handleISIPreviewVisibility();
	}



})();

// HCP Modal functionality
		(function() {
			var hcpModal = document.getElementById('hcp-modal');
			var hcpYesBtn = document.getElementById('hcp-yes');
			var hcpNoBtn = document.getElementById('hcp-no');
			var cookieName = 'hcp_modal_seen';
			var suppressInitialFocusClass = 'hcp-modal--suppress-initial-focus';

			function handleFirstModalTab(e) {
				if (e.key !== 'Tab') return;
				if (hcpModal) {
					hcpModal.classList.remove(suppressInitialFocusClass);
				}
				document.removeEventListener('keydown', handleFirstModalTab, true);
			}

		// Cookie utility functions
		function setCookie(name, value, days) {
			var expires = "";
			if (days) {
				var date = new Date();
				date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
				expires = "; expires=" + date.toUTCString();
			}
			document.cookie = name + "=" + (value || "") + expires + "; path=/";
		}

		function getCookie(name) {
			var nameEQ = name + "=";
			var ca = document.cookie.split(';');
			for (var i = 0; i < ca.length; i++) {
				var c = ca[i];
				while (c.charAt(0) == ' ') c = c.substring(1, c.length);
				if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
			}
			return null;
		}

				function showHCPModal() {
					if (hcpModal) {
						hcpModal.showModal();
						hcpModal.classList.add(suppressInitialFocusClass);
						document.removeEventListener('keydown', handleFirstModalTab, true);
						document.addEventListener('keydown', handleFirstModalTab, true);
						// Keep initial focus on the dialog itself so the primary button
						// does not show a focus ring until keyboard tabbing begins.
						if (!hcpModal.hasAttribute('tabindex')) {
							hcpModal.setAttribute('tabindex', '-1');
						}
					requestAnimationFrame(function() {
						try {
							hcpModal.focus({ preventScroll: true });
						} catch (e) {
							hcpModal.focus();
						}
					});
				}
			}

			function hideHCPModal() {
				if (hcpModal) {
					hcpModal.classList.remove(suppressInitialFocusClass);
					document.removeEventListener('keydown', handleFirstModalTab, true);
					hcpModal.close();
				}
			}

		// Check if user has seen the modal before
		function checkHCPModalStatus() {
			var hasSeenModal = getCookie(cookieName);
			if (!hasSeenModal) {
				// Show modal after a short delay to ensure page is loaded
				setTimeout(showHCPModal, 500);
			}
		}

		// Handle HCP Yes button click
		if (hcpYesBtn) {
			hcpYesBtn.addEventListener('click', function() {
				setCookie(cookieName, 'yes', 365); // Set cookie for 1 year
				hideHCPModal();
			});
		}

		// Handle HCP No button click - redirect to patient site
		if (hcpNoBtn) {
			hcpNoBtn.addEventListener('click', function() {
				setCookie(cookieName, 'no', 365); // Set cookie for 1 year
				// Replace with actual patient site URL
				window.location.href = 'https://ascendispharma.us/'; 
			});
		}

		// Prevent modal from closing when clicking outside or pressing ESC
		if (hcpModal) {
			hcpModal.addEventListener('cancel', function(e) {
				e.preventDefault(); // Prevent default close behavior
			});

			hcpModal.addEventListener('click', function(e) {
				if (e.target === hcpModal) {
					e.preventDefault(); // Prevent closing when clicking backdrop
				}
			});
		}

		// Initialize modal check on page load
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', checkHCPModalStatus);
		} else {
			checkHCPModalStatus();
		}
	})();

// Smooth scroll for ISI link with sticky header offset
(function(){
	if ( typeof document === 'undefined' ) return;

	function getHeaderOffset() {
		var offset = 0;
		var adminBar = document.getElementById('wpadminbar');
		if (adminBar) {
			offset += adminBar.offsetHeight || 0;
		}
		var header = document.querySelector('.site-header');
		if (header) {
			offset += header.offsetHeight || 0;
		}
		// Add a small extra margin so content isn't tight against the header
		offset += 16;
		return offset;
	}

	function smoothScrollToISI() {
		var isi = document.getElementById('isi');
		if (!isi) return;

		var offset = getHeaderOffset();
		var targetPosition = isi.getBoundingClientRect().top + window.pageYOffset - offset;

		window.scrollTo({
			top: targetPosition,
			behavior: 'smooth'
		});
	}

	document.addEventListener('click', function(e){
		var link = e.target.closest && e.target.closest('a[href="#isi"]');
		if (!link) return;
		e.preventDefault();
		smoothScrollToISI();
	});
})();

// Header Navigation and Form Interactions - Refactored for DRY principles
(function() {
	if (typeof document === 'undefined') return;

	// Utility functions
	const utils = {
		// Smooth scroll with header offset
		scrollToElement: function(element, offset = 60) {
			if (!element) return;
			const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
			const offsetPosition = elementPosition - offset;
			
			window.scrollTo({
				top: offsetPosition,
				behavior: 'smooth'
			});
		},

		// Find and interact with signup form
		handleSignupForm: function(checkContactMe = false) {
			const signupForm = document.querySelector('.signup-form#form');
			
			if (signupForm) {
				this.scrollToElement(signupForm, 360);
				
				if (checkContactMe) {
					const contactMeCheckbox = signupForm.querySelector('input[name="contact_me"]');
					if (contactMeCheckbox) {
						contactMeCheckbox.checked = true;
						contactMeCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
					}
				}
				return true;
			}
			return false;
		},

		// Focus-visible polyfill utilities
		initFocusVisible: function() {
			let hadKeyboardEvent = true;

			const onPointerDown = () => hadKeyboardEvent = false;
			const onKeyDown = (e) => {
				if (!e.metaKey && !e.altKey && !e.ctrlKey) {
					hadKeyboardEvent = true;
				}
			};
			const onFocus = (e) => {
				if (hadKeyboardEvent) {
					e.target.classList.add('focus-visible');
				}
			};
			const onBlur = (e) => e.target.classList.remove('focus-visible');

			// Add event listeners
			['keydown', 'mousedown', 'pointerdown', 'touchstart'].forEach(event => {
				document.addEventListener(event, event === 'keydown' ? onKeyDown : onPointerDown, true);
			});

			return { onFocus, onBlur };
		}
	};

	// Initialize focus-visible polyfill
	const { onFocus, onBlur } = utils.initFocusVisible();

	// Prescribing Info Dropdown functionality
	function initPrescriberDropdown() {
		const dropdown = document.querySelector('.prescribing-info-dropdown');
		const button = document.getElementById('prescribing-info-btn');
		const menu = document.getElementById('prescribing-dropdown');
		const arrow = button && button.querySelector('.dropdown-arrow');
		
		if (!dropdown || !button || !menu) return;

		// Apply focus-visible
		[button, ...menu.querySelectorAll('a[role="menuitem"]')].forEach(element => {
			element.addEventListener('focus', onFocus, true);
			element.addEventListener('blur', onBlur, true);
		});

		function toggleDropdown(show) {
			const isOpen = show !== undefined ? show : button.getAttribute('aria-expanded') !== 'true';
			
			button.setAttribute('aria-expanded', isOpen);
			menu.setAttribute('aria-hidden', !isOpen);
			
			if (isOpen) {
				arrow && arrow.classList.add('rotated');
				dropdown.classList.add('open');
				const firstMenuItem = menu.querySelector('a[role="menuitem"]');
				if (firstMenuItem) {
					setTimeout(() => firstMenuItem.focus(), 10);
				}
			} else {
				arrow && arrow.classList.remove('rotated');
				dropdown.classList.remove('open');
			}
		}

		// Event listeners
		button.addEventListener('click', (e) => {
			e.preventDefault();
			e.stopPropagation();
			toggleDropdown();
		});

		button.addEventListener('keydown', (e) => {
			switch(e.key) {
				case 'Enter':
				case ' ':
					e.preventDefault();
					toggleDropdown();
					break;
				case 'ArrowDown':
					e.preventDefault();
					toggleDropdown(true);
					break;
				case 'Escape':
					toggleDropdown(false);
					button.focus();
					break;
			}
		});

		menu.addEventListener('keydown', (e) => {
			const menuItems = Array.from(menu.querySelectorAll('a[role="menuitem"]'));
			const currentIndex = menuItems.indexOf(document.activeElement);

			switch(e.key) {
				case 'ArrowDown':
					e.preventDefault();
					const nextIndex = (currentIndex + 1) % menuItems.length;
					menuItems[nextIndex].focus();
					break;
				case 'ArrowUp':
					e.preventDefault();
					const prevIndex = currentIndex > 0 ? currentIndex - 1 : menuItems.length - 1;
					menuItems[prevIndex].focus();
					break;
				case 'Escape':
					e.preventDefault();
					toggleDropdown(false);
					button.focus();
					break;
				case 'Tab':
					toggleDropdown(false);
					break;
			}
		});

		// Close handlers
		document.addEventListener('click', (e) => {
			if (!dropdown.contains(e.target)) {
				toggleDropdown(false);
			}
		});

		document.addEventListener('focusin', (e) => {
			if (!dropdown.contains(e.target)) {
				toggleDropdown(false);
			}
		});

		// Hover states
		dropdown.addEventListener('mouseenter', () => {
			dropdown.classList.add('hover');
			arrow && arrow.classList.add('rotated');
		});

		dropdown.addEventListener('mouseleave', () => {
			dropdown.classList.remove('hover');
			if (!dropdown.classList.contains('open')) {
				arrow && arrow.classList.remove('rotated');
			}
			setTimeout(() => {
				if (!dropdown.classList.contains('hover') && !dropdown.contains(document.activeElement)) {
					toggleDropdown(false);
				}
			}, 100);
		});

		// Touch support
		dropdown.addEventListener('touchstart', () => {
			dropdown.classList.add('hover');
			arrow && arrow.classList.add('rotated');
		});

		document.addEventListener('touchstart', (e) => {
			if (!dropdown.contains(e.target)) {
				dropdown.classList.remove('hover');
				if (!dropdown.classList.contains('open')) {
					arrow && arrow.classList.remove('rotated');
				}
			}
		});
	}

	// Form scroll functionality
	function initFormScrollButtons() {
		// Handle "Request a Rep" buttons
		document.querySelectorAll('.request-rep-btn').forEach(button => {
			button.addEventListener('click', (e) => {
				e.preventDefault();
				
				if (!utils.handleSignupForm(true)) {
					// If form doesn't exist, redirect to home page with #rep hash
					window.location.href = '/#rep';
				}
			});
		});

		// Handle "Sign up today" buttons
		document.querySelectorAll('.sign-up-scroll-btn').forEach(button => {
			button.addEventListener('click', (e) => {
				e.preventDefault();
				utils.handleSignupForm(false);
			});
		});
	}

	// Hash-based navigation
	function initHashNavigation() {
		function handleRepHash() {
			if (window.location.hash === '#rep') {
				const signupForm = document.querySelector('.signup-form#form');
				
				if (signupForm) {
					setTimeout(() => {
						utils.handleSignupForm(true);
					}, 100);
				}
			}
		}

		// Handle hash on initial page load and changes
		handleRepHash();
		window.addEventListener('hashchange', handleRepHash);
	}

	// Remove duplicate mobile accordion functionality since it's already handled above
	// The existing mobile accordion code in the main mobile menu section is sufficient

	// Initialize all functionality
	function init() {
		initPrescriberDropdown();
		initFormScrollButtons();
		initHashNavigation();
	}

	// Initialize when DOM is ready
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
